import React from "react";

import { Link } from "../../../Link";
import { Text } from "../../../Text";
import { NotificationSection } from "../../../NotificationSection";

import "./styles.scss";
import { SUPPORT_NUMBER, SUPPORT_NUMBER_HREF } from "../../../../constants/aptihealth";

// Relates to: Profile Insurance Status

export const NoMatch = ({ copay, carrier, dateChecked }) => {
  return (
    <NotificationSection className="declined">
      <Text className="bold mb-3">We couldn’t verify your insurance.</Text>

      <Text>
        <>
          <div className="mb-3">
            Double check that the information below is correct and try again.
          </div>
          <div className="mb-3">
            If your info looks correct, contact{" "}
            <Link href="mailto:support@aptihealth.com">support@aptihealth.com</Link> or{" "}
            <Link href={SUPPORT_NUMBER_HREF}>{SUPPORT_NUMBER}</Link> before your next appointment to
            prevent billing issues.
          </div>
          <div>Checked: {dateChecked}</div>
        </>
      </Text>
    </NotificationSection>
  );
};

NoMatch.defaultProps = {
  copay: null,
  dateChecked: "",
  carrier: "",
};
